import React from 'react';
import './GuidedIngestionPage.css';

type GuidedIngestionPageProps = {
  onStartJob: () => void;
  onStartResume: () => void;
  onSkip: () => void;
};

export const GuidedIngestionPage: React.FC<GuidedIngestionPageProps> = ({
  onStartJob,
  onStartResume,
  onSkip,
}) => {
  return (
    <div className="v2-page guided-ingestion-page">
      <div className="guided-ingestion-hero">
        <h1>Refined Ingestion Hub</h1>
        <p>Securely ingest job descriptions and candidate resumes to begin 8D scoring.</p>
      </div>

      <div className="guided-ingestion-grid">
        <article className="guided-ingestion-card">
          <h2>1. Enter Job Description</h2>
          <p>
            Create the role first so matching and scoring can anchor to a specific job profile.
          </p>
          <button className="v2-btn v2-btn-primary" onClick={onStartJob}>
            Enter Job Description
          </button>
        </article>

        <article className="guided-ingestion-card">
          <h2>2. Upload Resumes</h2>
          <p>
            Upload one or many resumes. Single upload opens Resume Workspace, multi upload lands in Talent Pool.
          </p>
          <button className="v2-btn v2-btn-primary" onClick={onStartResume}>
            Upload Resumes
          </button>
        </article>
      </div>

      <div className="guided-ingestion-footer">
        <button className="v2-btn v2-btn-ghost" onClick={onSkip}>
          Skip guided setup and open dashboard
        </button>
      </div>
    </div>
  );
};
